export const vms_gen7 = [
  { name: "VM01 Zerschneider", location: "nicht vorhanden – durch PokéMobil ersetzt (Kosturso)" },
  { name: "VM02 Fliegen", location: "nicht vorhanden – durch PokéMobil ersetzt (Glurak)" },
  { name: "VM03 Surfer", location: "nicht vorhanden – durch PokéMobil ersetzt (Lapras)" },
  { name: "VM04 Stärke", location: "nicht vorhanden – durch PokéMobil ersetzt (Taurous)" },
  { name: "VM05 Blitz", location: "nicht vorhanden – kein Ersatz nötig" },
  { name: "VM06 Zertrümmerer", location: "nicht vorhanden – durch PokéMobil ersetzt (Taurous)" },
  { name: "VM07 Taucher", location: "nicht vorhanden – durch PokéMobil ersetzt (Mantax)" },
  { name: "VM08 Kaskade", location: "nicht vorhanden – nicht mehr notwendig" }
];
